// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Iz6c","comment":"styles_comment__1IqAy"};